import { ArrowRight, BookOpen, Clapperboard, Compass, Rocket, Signpost } from 'lucide-react';
import Reveal from './Reveal';

const STEPS = [
  {
    icon: Compass,
    n: '01',
    title: 'Explore',
    desc: 'Understand filmmaking and discover the different disciplines.',
  },
  {
    icon: Signpost,
    n: '02',
    title: 'Choose',
    desc: 'Find the area of filmmaking you actually want to pursue.',
  },
  {
    icon: BookOpen,
    n: '03',
    title: 'Learn',
    desc: 'Through structured, specialised programs.',
  },
  {
    icon: Clapperboard,
    n: '04',
    title: 'Practice',
    desc: 'Apply concepts through hands-on assignments.',
  },
  {
    icon: Rocket,
    n: '05',
    title: 'Build',
    desc: 'Create work, build a portfolio and move toward the industry.',
  },
];

const StructuredPath = () => (
  <section data-testid="structured-path-section" className="bg-black py-20 md:py-28">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal className="mx-auto mb-16 max-w-3xl text-center">
        <h2 className="display-heading text-3xl text-white sm:text-4xl lg:text-5xl">
          A structured <em>path into filmmaking.</em>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-zinc-400 md:text-base">
          Cynopsis helps aspiring filmmakers explore the craft, choose their direction and build
          real skills - before making big career or financial commitments.
        </p>
      </Reveal>

      <div className="relative">
        <div
          className="step-rail absolute left-[10%] right-[10%] top-7 hidden h-px lg:block"
          aria-hidden="true"
        />

        <ol className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-5 lg:gap-4">
          {STEPS.map(({ icon: Icon, n, title, desc }, idx) => (
            <Reveal
              key={n}
              as="li"
              delay={idx * 0.1}
              className="relative flex flex-col items-center px-2 text-center"
            >
              <span className="relative z-10 mb-5 flex h-14 w-14 items-center justify-center rounded-full border border-white/10 bg-black transition-colors duration-300 hover:border-[#A80D1A]">
                <Icon className="h-6 w-6 text-[#C8102E]" strokeWidth={1.4} />
              </span>

              <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-white">
                <span className="text-[#C8102E]">{n}</span> {title}
              </p>

              <p className="max-w-[15rem] text-xs leading-relaxed text-zinc-500">{desc}</p>

              {idx < STEPS.length - 1 && (
                <ArrowRight
                  className="absolute -right-2 top-[22px] hidden h-4 w-4 text-zinc-600 lg:block"
                  aria-hidden="true"
                />
              )}
            </Reveal>
          ))}
        </ol>
      </div>
    </div>
  </section>
);

export default StructuredPath;
